import BaseService from '../base'

class feedback extends BaseService {
    // 获取反馈列表
    async feedbackList(postData) {
        return await this.get('/question_feedback', postData);
    }
    // 创建反馈问题
    async addFeedback(postData) {
        return await this.post(`/question_feedback`, postData);
    }
}

export default new feedback();